import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavButton = ({ title, redirect, onClick }) => {
    
    const navigate = useNavigate();

    const handleClick = async () => {
        await onClick();
        await new Promise(resolve => setTimeout(resolve, (1000)));
        navigate(redirect);
    };

    return (
        <button id="nav-button" className="w-32 h-full flex justify-center items-top border-white hover:border-b-4 transition-all ease-linear transition-100 cursor-pointer" onClick={() => handleClick()}>
            <p className="c-white josefin-400 m-0 pt-7 scale-y-90">{title}</p>
        </button>
    );
}

export default NavButton;
